import { createUseStyles } from "react-jss";
import { AppTheme } from "../../../../types/styles.types";

export const useStylesFilters: any = createUseStyles((theme: AppTheme) => ({
  renderValue: {
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
  },
  filterValue: {
    color: theme.textColor,
  },
  searchInputWrapper: {
    width: "304px",
    position: "relative",
    marginTop: "8px",
  },
  closeBtn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute ",
    right: "8px",
    top: "12%",
    padding: "8px",
    cursor: "pointer",
    borderRadius: "100%",
    width: "32px",
    height: "32px",
    "&:hover": {
      background: "rgba(0, 0, 0, 0.04)",
    },
  },
  searchInput: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    border: "1px solid transparent",
    width: "304px",
    backgroundRepeat: "no-repeat",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "1.5",
    color: "#444444",
    display: "block",
    padding: "12px 16px",
    backgroundPosition: "252px center",
    backgroundSize: "20px 20px",
    "&:focus": {
      border: "1px solid #D9D9D9",
    },

    "&:hover ": {
      border: "1px solid #D9D9D9",
      boxShadow: "0px 0px 4px 0px #E8E8E8",
    },

    "&:disabled": {
      border: "1px solid transparent",
      backgroundColor: "rgba(15, 49, 77, 0.04)",
      boxShadow: "none",
    },

    "&:focus-visible": {
      outline: "none",
    },

    "&::placeholder": {
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "1.5",
      color: "#b7b7b7",
    },

    "&:focus::placeholder": {
      color: "transparent",
    },
  },
}));
